import React, { useState, useEffect, useRef } from 'react'
import { Modal, Button, ButtonGroup, Dropdown, Form, Row, Col, Container, Spinner } from 'react-bootstrap'
import { useWatch } from 'react-hook-form'
import { IoSearch } from "react-icons/io5";
import { FaRegEye, FaWhatsapp } from "react-icons/fa";
import ModalSearchPacientes from '../ModalSearch/ModalSearchPacientes';
import CadastroPaciente from '../../pages/cadastro_paciente';
import ModalSearchTecnicos from '../ModalSearch/ModalSearchTecnicos';
import ModalSearchTipoAtendimento from '../ModalSearch/ModalSearchTipoAtendimento';
import CadastroProntuarios from '../../pages/cadastro_prontuarios';
import ModalSearchProntuarios from '../ModalSearch/ModalSearchProntuarios';
import Agendamentos from '../../services/Agendamentos';
import Tecnicos from '../../services/Tecnicos';
import { SweetAlert } from '../sweetalert';
import { addMinutes, subMinutes, format, getDay, parseISO } from 'date-fns';
import { buildOccurrences, formatDateBR, isValidDate, isValidTime, moveStart, nextWeeklyDate, shortWeekDay } from '../../utilities/agendamentoSeries';
import { useAgendamentoSeries } from '../Agendamento/useAgendamentoSeries';
import { useAgendamentoCheck } from '../Agendamento/useAgendamentoCheck';
import { useNextSlot } from '../Agendamento/useNextSlot';
import RepeatAgendamento from '../Agendamento/RepeatAgendamento';
import AgendamentoCheck from '../Agendamento/AgendamentoCheck';
import NextSlotNote from '../Agendamento/NextSlotNote';
import AgendamentoBatchSummary from '../Agendamento/AgendamentoBatchSummary';
import AgendamentoWhatsapp, { openAgendamentoWhatsapp } from '../Agendamento/AgendamentoWhatsapp';
import { upcomingSessions } from '../../utilities/agendamentoWhatsapp';
import { whatsappNumber } from '../../utilities/birthdays';
import { formatarTelefone } from '../../utilities/formatarTelefoneInput';
import { useAgendamentoAttendance } from '../Agendamento/useAgendamentoAttendance';
import AgendamentoAttendance from '../Agendamento/AgendamentoAttendance';
import { shouldAskAttendance, tecnicoAsksAttendance } from '../../utilities/attendance';
import { prontuarioLabel } from '../../utilities/prontuarioLabel';
import { useLatestProntuario } from '../useLatestProntuario';
import { useAuth } from '../../context/auth';
import { useMediaQuery } from '../Agendamento/useMediaQuery';
import './ModalNovoAgendamento.css';

// Celular: o mesmo limite do modal em tela cheia (fullscreen='sm-down') e do rodapé empilhado no CSS
const PHONE_LAYOUT = '(max-width: 575.98px)';

const ModalNovoAgendamento = ({ show, handleClose, setAgendamentos, register, setValue, getValues,
  //  reset,
  listAll, control, status, goToDate }) => {

  const [showCliente, setShowCliente] = useState(false);
  const [showTecnico, setShowTecnico] = useState(false);
  const [showTipoAtendimento, setShowTipoAtendimento] = useState(false);
  const [showProntuarios, setShowProntuarios] = useState(false);
  const [showModalCadastroPessoa, setShowModalCadastroPessoa] = useState(false);
  const [showModalCadastroProntuario, setShowModalCadastroProntuario] = useState(false);

  const [, setShowNext] = useState(false);
  const [nextTitle, setNextTitle] = useState(false);

  const [loading, setLoading] = useState(false);

  const [id, setId] = useState(null);
  const [, setValues] = useState(null);

  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [batchAlert, setBatchAlert] = useState(null); // { variant, title, text }
  // lote salvo (ou o agendamento único do "Salvar e enviar", com single): { ids, sessions, paciente, tecnico, tipo, status, startTime,
  // single, updated (agendamento aberto), patient (paciente da resposta, com os telefones), pacienteId, whatsapp ('opened' | 'blocked' | null) }
  const [summary, setSummary] = useState(null);
  const [confirm, setConfirm] = useState(null); // 'discard' | 'undo' | 'delete'
  const [saveMenu, setSaveMenu] = useState(false); // celular: menu aberto com as outras opções de salvar
  const [lastSession, setLastSession] = useState(null);
  const noResponse = useRef(false); // o envio anterior do lote ficou sem resposta
  const startAtFocus = useRef('');

  const { user } = useAuth();
  const phone = useMediaQuery(PHONE_LAYOUT);
  const attendance = useAgendamentoAttendance();
  const savedStatus = useRef(null); // status gravado do agendamento aberto (null no novo): a pergunta do atendimento só vem quando ele muda
  const prontuarioDoctor = useRef(null); // doutor que veio do prontuário: o Doutor acompanha o prontuário até a pessoa escolher outro
  const prontuarioFill = useLatestProntuario({ getValues, setValue, showProgress: true, onFill: setProntuarioDoctor });

  // useWatch assina só este componente; o watch re-renderiza a Agenda inteira a cada mudança
  const [dataInicial, horaInicial, horaFinal, tecnicoId, pacienteId, statusId] = useWatch({
    control,
    name: ['data_inicial', 'hora_inicial', 'hora_final', 'tecnico_id', 'paciente_id', 'status'],
  });

  const series = useAgendamentoSeries({
    main: { date: dataInicial, start_time: horaInicial, end_time: horaFinal },
    tecnicoId,
    pacienteId,
  });

  // Agendamento aberto: doutor, data, horários e status como vieram (a Agenda preenche a data e os horários um instante
  // depois do id). A verificação só impede salvar o que o servidor recusaria: mover (outro doutor, data ou horário)
  // ou voltar a ocupar o horário (status que libera para um que ocupa)
  const [opened, setOpened] = useState(null);

  useEffect(() => {
    if (id !== null && !opened && tecnicoId && isValidDate(dataInicial) && isValidTime(horaInicial) && isValidTime(horaFinal))
      setOpened({ tecnicoId, date: dataInicial, startTime: horaInicial, endTime: horaFinal, statusId });
  }, [id, opened, tecnicoId, dataInicial, horaInicial, horaFinal, statusId]);

  const moved = Boolean(opened) && (tecnicoId !== opened.tecnicoId || dataInicial !== opened.date || horaInicial !== opened.startTime || horaFinal !== opened.endTime);
  const reoccupies = Boolean(opened) && releasesSlot(opened.statusId) && !releasesSlot(statusId);

  // Sem repetição (novo ou aberto): a mesma verificação da lista do lote, para a sessão única. No aberto, só com a
  // permissão de criar agendamento (a mesma da rota da verificação), e sem contar o próprio agendamento
  const singleCheck = useAgendamentoCheck({
    enabled: show && !series.enabled && !summary && (id === null || Boolean(user?.features?.includes('create:agendamento'))),
    tecnicoId,
    pacienteId,
    agendamentoId: id,
    date: dataInicial,
    startTime: horaInicial,
    endTime: horaFinal,
    enforce: id === null ? undefined : { serviceHours: moved, slot: moved || reoccupies },
  });

  // Agendamento novo: Data, Início e Fim no primeiro horário livre do doutor. Não vale no aberto (o id chega pelo formulário
  // antes do estado) nem nas "próximas sessões", que mantêm o horário da semana
  const nextSlot = useNextSlot({
    enabled: show && id === null && !getValues('id') && !nextTitle && !summary,
    tecnicoId,
    date: dataInicial,
    startTime: horaInicial,
    endTime: horaFinal,
    setValue,
  });

  useEffect(() => {

    if (show === true) {


      const values = getValues()
      setValues(values)
      savedStatus.current = null

      if (getValues('id') !== undefined && getValues('id') !== null && getValues('id') !== '') {
        setId(getValues('id'));
        setShowNext(true)
        savedStatus.current = getValues('status')
      }
    }

  }, [show]);

  // A lista de status pode chegar depois que o modal abriu: no agendamento novo, aplica o status padrão
  useEffect(() => {
    if (show && !getValues('id') && !getValues('status') && status?.length > 0) setValue('status', status[0].id)
  }, [show, status]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleCloseCliente = () => setShowCliente(false);
  const handleShowCliente = () => setShowCliente(true);
  const handleCloseTecnico = () => setShowTecnico(false);
  const handleShowTecnico = () => setShowTecnico(true);
  const handleShowModalCadastroPessoa = () => setShowModalCadastroPessoa(true);
  const handleCloseModalCadastroPessoa = () => setShowModalCadastroPessoa(false);
  const handleCloseProntuarios = () => setShowProntuarios(false);
  const handleShowProntuarios = () => setShowProntuarios(true);
  const handleShowModalCadastroProntuario = () => setShowModalCadastroProntuario(true);
  const handleCloseModalCadastroProntuario = () => setShowModalCadastroProntuario(false);
  const handleShowTipoAtendimento = () => setShowTipoAtendimento(true);
  const handleCloseTipoAtendimento = () => setShowTipoAtendimento(false);

  // Trocar o paciente limpa o prontuário, que era do paciente anterior. Com o campo vazio, já traz o do paciente
  // escolhido: o único ou, com mais de um, o último cadastrado (a lupa continua liberada para trocar)
  function setPacienteValue(name, value) {
    if (name === 'paciente_id' && value !== getValues('paciente_id')) {
      setValue('prontuario_id', null)
      setValue('prontuario', '')
      // Os telefones dos ícones do WhatsApp (agendamento aberto) eram do paciente anterior
      setValue('telefone1', '')
      setValue('telefone2', '')
      // O doutor que veio do prontuário do paciente anterior sai com ele
      if (prontuarioDoctor.current && getValues('tecnico_id') === prontuarioDoctor.current) {
        setValue('tecnico_id', '')
        setValue('tecnico', '')
      }
      prontuarioDoctor.current = null
    }
    setValue(name, value)
    if (name === 'paciente_id' && !getValues('prontuario_id')) prontuarioFill.fill(value)
  }

  // O Doutor vem do prontuário (o automático do paciente, o da lupa ou o cadastrado por ela): no campo vazio ou no que já
  // tinha vindo de outro prontuário. O doutor escolhido pela pessoa, o da Agenda (doutor logado ou chip da Lista) e o do
  // agendamento aberto ficam. Doutor inativo não vem
  function setProntuarioDoctor(prontuario) {
    const doctor = prontuario?.tecnico_responsavel
    if (!doctor?.id || doctor.ativo === false) return

    const current = getValues('tecnico_id')
    if (current && current !== prontuarioDoctor.current) return

    prontuarioDoctor.current = doctor.id
    setValue('tecnico_id', doctor.id)
    setValue('tecnico', doctor.nome)
  }

  // A busca do doutor: a escolha da pessoa, que o prontuário não troca mais
  function setTecnicoValue(name, value) {
    prontuarioDoctor.current = null
    setValue(name, value)
  }

  function closeAll() {
    handleClose()
    setId(null)
    setShowNext(false)
    setNextTitle(false)
    // reset()
    setValue('id', '');
    setValue("paciente_id", '')
    setValue("paciente", '')
    setValue("prontuario_id", null)
    setValue("prontuario", '')
    setValue("tecnico_id", '')
    setValue("tecnico", '')
    setValue("tipo_atendimento_id", '')
    setValue("tipo_atendimento", '')
    setValue("data_inicial", '')
    setValue("hora_inicial", '')
    setValue("hora_final", '')
    setValue("status", '')
    setValue("telefone1", '')
    setValue("telefone2", '')

    // O modal fica sempre montado: a série e o resumo são limpos aqui
    series.clear()
    setBatchAlert(null)
    setSummary(null)
    setConfirm(null)
    setSaveMenu(false)
    setLastSession(null)
    setOpened(null)
    noResponse.current = false
    attendance.clear()
    prontuarioFill.cancel()
    prontuarioDoctor.current = null
  }

  // Fechar pelo X: com a lista montada, pede confirmação no rodapé
  function requestClose() {
    if (saving || deleting) return

    if (series.enabled && series.sessions.length > 1 && !summary) {
      setConfirm('discard')
      return
    }

    closeAll()
  }


  // Devolve true quando salvou
  async function onSubmit(origem = 'salvar') {

    const data = getValues();

    const dataInicialObj = new Date(data.data_inicial + 'T' + data.hora_inicial);
    const dataFinalObj = new Date(data.data_inicial + 'T' + data.hora_final);

    if (dataFinalObj <= dataInicialObj) {
      SweetAlert.error("A hora final não pode ser menor ou igual à hora inicial.");
      return false;
    }

    if (data.paciente === '' || data.paciente === undefined || data.paciente === null) {
      SweetAlert.error('Paciente é um campo obrigatório', 'Agendamento');
      return false;
    }

    if (data.tecnico === '' || data.tecnico === undefined || data.tecnico === null) {
      SweetAlert.error('Doutor é um campo obrigatório', 'Agendamento');
      return false;
    }

    if (data.tipo_atendimento_id === '' || data.tipo_atendimento_id === undefined || data.tipo_atendimento_id === null) {
      SweetAlert.error('Tipo de atendimento é um campo obrigatório', 'Agendamento');
      return false;
    }

    if (data.data_inicial === '' || data.data_inicial === undefined || data.data_inicial === null) {
      SweetAlert.error('Data inicial é um campo obrigatório', 'Agendamento');
      return false;
    }

    // Só confere se há status: a lista da Agenda pode não ter o de um agendamento aberto. O backend valida o id
    if (!data.status) {
      SweetAlert.error('Status é um campo obrigatório', 'Agendamento');
      return false;
    }

    if (id === null && series.enabled) return saveBatch(data);

    // A mesma recusa que a verificação mostra abaixo da data (os botões já ficam desabilitados)
    if (singleCheck.blocking) {
      SweetAlert.error(singleCheck.blocking, 'Agendamento');
      return false;
    }

    const newAgendamento = {
      "paciente_id": data.paciente_id,
      "prontuario_id": data.prontuario_id || null,
      "tecnico_id": data.tecnico_id,
      "tipo_atendimento_id": data.tipo_atendimento_id,
      "data_agendamento_inicial": data.data_inicial + 'T' + data.hora_inicial,
      "data_agendamento_final": data.data_inicial + 'T' + data.hora_final,
      "status_id": data.status
    }

    // Status mudou para um marcado com "Lançar atendimento" e agendamento com prontuário: pergunta antes de salvar,
    // se o doutor do agendamento também estiver marcado no cadastro dele (lido só neste caso)
    let askAttendance = shouldAskAttendance({
      statusList: status,
      statusId: data.status,
      savedStatusId: savedStatus.current,
      prontuarioId: data.prontuario_id,
      canLaunch: user?.features?.includes('update:prontuario') && user?.features?.includes('read:tecnico'),
    });
    if (askAttendance) {
      askAttendance = await loadTecnicoAsksAttendance(data.tecnico_id);
      if (askAttendance === null) return false;
    }
    const launch = askAttendance ? await attendance.ask(data.prontuario) : 'no';
    if (!launch) return false;

    let saved = null; // agendamento gravado (resposta do servidor, com os telefones do paciente)

    if (launch === 'yes') {
      // O Salvar do atendimento grava o agendamento e, depois, o atendimento
      const result = await attendance.open({
        prontuarioId: data.prontuario_id,
        prontuario: data.prontuario,
        tecnicoId: data.tecnico_id,
        tecnico: data.tecnico,
        date: data.data_inicial,
        save: async () => (saved = await saveAgendamento(newAgendamento)),
      });
      if (!result.saved) return false;

      if (result.launched) {
        SweetAlert.success('Agendamento salvo e atendimento lançado no prontuário', 'Agendamento');
        if (result.prontuario?.id === getValues('prontuario_id')) setValue('prontuario', prontuarioLabel(result.prontuario));
      } else {
        SweetAlert.warn('Agendamento salvo, sem lançar o atendimento', 'Agendamento');
      }
    } else {
      saved = await saveAgendamento(newAgendamento);
      if (!saved) return false;
      SweetAlert.success(id !== null ? 'Registro atualizado com sucesso' : 'Agendamento cadastrado com sucesso', 'Agendamento');
    }

    if (origem === 'whatsapp') {
      shareSaved(data, saved)
    } else if (origem === 'salvar') {
      closeAll()
    }
    listAll(false, getValues('date'))
    return true;
  }

  // "Salvar e enviar" do agendamento único (novo ou aberto pela agenda): o modal mostra o resumo, com uma sessão, e o
  // WhatsApp do paciente já abre em outra aba. Sem o Desfazer: o Salvar não tem, e o atendimento lançado ficaria no prontuário
  function shareSaved(data, saved) {
    const sessions = [{ key: data.data_inicial, date: data.data_inicial, start_time: data.hora_inicial, end_time: data.hora_final }];
    const patient = saved?.paciente ?? null;

    setSummary({
      ids: saved?.id ? [saved.id] : [],
      sessions,
      paciente: data.paciente,
      tecnico: data.tecnico,
      tipo: data.tipo_atendimento,
      status: status.find((item) => item.id === data.status)?.nome,
      startTime: null, // sem o horário "de cima": o resumo mostra o horário ao lado do dia
      single: true,
      updated: id !== null, // agendamento aberto pela agenda: "Agendamento atualizado"
      patient,
      pacienteId: data.paciente_id,
      whatsapp: openAgendamentoWhatsapp(patient, sessions),
    });
  }

  // Lê o cadastro do doutor do agendamento; devolve null quando não deu para conferir (o erro já aparece na tela)
  async function loadTecnicoAsksAttendance(tecnicoId) {
    setSaving(true);
    try {
      const { data } = await Tecnicos.listId(tecnicoId);
      return tecnicoAsksAttendance(data);
    } catch (error) {
      SweetAlert.error(`Não foi possível conferir o cadastro do doutor. ${error?.response?.data?.message ?? error?.message ?? ''}`, 'Agendamento');
      return null;
    } finally {
      setSaving(false);
    }
  }

  // Grava o agendamento único; quando salvou, devolve o agendamento gravado (ou true, sem corpo na resposta).
  // Recusado, devolve false (a recusa já aparece na tela)
  async function saveAgendamento(newAgendamento) {
    setSaving(true);
    try {
      let response;
      if (id !== null) {
        response = await Agendamentos.update(id, newAgendamento);
      } else {
        response = await Agendamentos.create(newAgendamento);
      }
      return response?.data || true;
    } catch (error) {
      SweetAlert.error(error?.response?.data?.message ?? error?.message, 'Agendamento');
      return false;
    } finally {
      setSaving(false);
    }
  }

  // Grava todas as sessões numa requisição só: tudo ou nada
  async function saveBatch(data) {
    if (series.blocking) {
      SweetAlert.error(series.blocking, 'Agendamento');
      return false;
    }

    const sessions = series.sessions;
    const body = {
      paciente_id: data.paciente_id,
      prontuario_id: data.prontuario_id || null,
      tecnico_id: data.tecnico_id,
      tipo_atendimento_id: data.tipo_atendimento_id,
      status_id: data.status,
      occurrences: buildOccurrences(sessions),
    };

    setSaving(true);
    setBatchAlert(null);
    try {
      const { data: created } = await Agendamentos.createBatch(body);
      noResponse.current = false;
      return finishBatch(data, sessions, created.map((agendamento) => agendamento.id), created[0]?.paciente);
    } catch (error) {
      const statusCode = error?.response?.status;
      const response = error?.response?.data;

      // Sem resposta, 5xx ou página de erro de proxy: não dá para saber se gravou
      if (!(statusCode >= 400 && statusCode < 500)) {
        noResponse.current = true;
        setBatchAlert({
          variant: 'warning',
          title: 'Sem resposta do servidor.',
          text: 'Não dá para saber se os agendamentos foram gravados. Clique em salvar de novo: se já tiverem sido, o sistema reconhece e mostra o resumo, sem duplicar.',
        });
        return false;
      }

      const conflicts = response?.context?.conflicts ?? [];
      const allAlreadyScheduled = conflicts.length === sessions.length && conflicts.every((conflict) => conflict.reason === 'ALREADY_SCHEDULED');

      // Foi o próprio envio anterior, que ficou sem resposta, que gravou
      if (allAlreadyScheduled && noResponse.current) {
        noResponse.current = false;
        return finishBatch(data, sessions, conflicts.flatMap((conflict) => (conflict.existing_agendamentos ?? []).map((agendamento) => agendamento.id)));
      }

      // Erro do Validator num item: "occurrences[2].data_agendamento_inicial"
      const index = /occurrences\[(\d+)\]/.exec(response?.key ?? '')?.[1];
      const marks = conflicts.length ? conflicts : (index !== undefined ? [{ index: Number(index), blocking: true, message: response.message }] : null);
      if (marks) series.markConflicts(marks, sessions, { replace: response?.type === 'agendamento.batch_conflict' });

      setBatchAlert(allAlreadyScheduled
        ? { variant: 'info', title: 'Nada foi criado de novo.', text: `Estas ${sessions.length} sessões já estão agendadas para este paciente.` }
        : { variant: 'danger', title: 'Nada foi salvo.', text: refusalText(response, conflicts, sessions) });
      return false;
    } finally {
      setSaving(false);
    }
  }

  // Montado a partir das datas, sem nomes de pacientes
  function refusalText(response, conflicts, sessions) {
    if (response?.type !== 'agendamento.batch_conflict') return `${response?.message ?? ''} ${response?.action ?? ''}`.trim();

    const dates = conflicts.filter((conflict) => conflict.blocking).map((conflict) => formatDateBR(sessions[conflict.index]?.date));

    return dates.length === 1
      ? `A data ${dates[0]} está ocupada na agenda do doutor. Pule essa data ou mude o horário e salve de novo.`
      : `As datas ${dates.join(', ')} estão ocupadas na agenda do doutor. Pule essas datas ou mude o horário e salve de novo.`;
  }

  // patient: paciente da resposta, com os telefones para o WhatsApp. Sem ele (lote reconhecido depois de ficar sem
  // resposta), o envio pelo WhatsApp lê o cadastro do paciente
  function finishBatch(data, sessions, ids, patient = null) {
    const dates = sessions.map((session) => session.date).sort();

    SweetAlert.success(`${sessions.length} agendamentos cadastrados, de ${formatDateBR(dates[0])} a ${formatDateBR(dates[dates.length - 1])}.`, 'Agendamento');
    setSummary({
      ids,
      sessions,
      paciente: data.paciente,
      tecnico: data.tecnico,
      tipo: data.tipo_atendimento,
      status: status.find((item) => item.id === data.status)?.nome,
      startTime: data.hora_inicial,
      patient,
      pacienteId: data.paciente_id,
      releasesSlot: releasesSlot(data.status), // status que libera o horário: não há data a enviar ao paciente
    });
    listAll(false, getValues('date'))
    return true;
  }

  // Status com "Libera o horário" (ex.: desmarcado): o agendamento não ocupa a agenda, e a mensagem diria "está agendado"
  function releasesSlot(statusIdValue) {
    return Boolean(status?.find((item) => item.id === statusIdValue)?.releases_slot);
  }

  // Desfazer: exclui de uma vez os agendamentos que o lote criou
  async function undoBatch() {
    setSaving(true);
    try {
      const { data } = await Agendamentos.deleteBatch(summary.ids);
      const total = data.total_deleted;
      SweetAlert.success(total === 1 ? '1 agendamento excluído.' : `${total} agendamentos excluídos.`, 'Agendamento');
      closeAll()
      listAll(false, getValues('date'))
    } catch (error) {
      SweetAlert.error(error?.response?.data?.message ?? error?.message, 'Agendamento');
      setConfirm(null);
    } finally {
      setSaving(false);
    }
  }

  // Agendamento novo, repetição desligada: só avança se salvou
  async function marcarPróximo() {
    const origem = getValues('data_inicial')

    if (!(await onSubmit('proximo'))) return

    prepareNext(origem)
  }

  // Edição: salva o agendamento aberto e já liga a série a partir da semana seguinte
  async function saveAndScheduleNext() {
    const origem = getValues()

    if (!(await onSubmit('proximo'))) return

    const statusName = status.find((item) => item.id === origem.status)?.nome
    setLastSession(`Última sessão: ${shortWeekDay(origem.data_inicial)} ${formatDateBR(origem.data_inicial)}, ${origem.hora_inicial}–${origem.hora_final}${statusName ? ` · ${statusName}` : ''}`)
    prepareNext(origem.data_inicial)
    series.startNext(getDay(parseISO(origem.data_inicial)))
  }

  // O status volta para o padrão e a data vai para uma semana depois, nunca antes de hoje
  function prepareNext(dataOrigem) {
    setId(null)
    setValue('id', '')
    savedStatus.current = null
    setOpened(null)
    setNextTitle(true)
    setValue('status', status[0]?.id ?? '')

    const proxima = nextWeeklyDate(dataOrigem)
    if (proxima) setValue('data_inicial', proxima)
  }

  function showSelectedPaciente() {
    const paciente_id = getValues('paciente_id')

    if (paciente_id === undefined) {
      return SweetAlert.error('Selecione um paciente antes de visualizar seus dados', 'Paciente')
    }

    const url = `/pacientes/cadastro/${paciente_id}`
    window.open(url, '_blank')
  }

  function showSelectedProntuario() {
    const prontuario_id = getValues('prontuario_id')

    // Vazio também é null (trocar o paciente e fechar o modal limpam o campo assim)
    if (!prontuario_id) {
      return SweetAlert.error('Selecione um prontuário antes de visualizar seus dados', 'Prontuário')
    }

    const url = `/prontuario/cadastro/${prontuario_id}`
    window.open(url, '_blank')
  }

  function add15min() {

    if (horaFinal) {
      const [hours, minutes] = horaFinal.split(':').map(Number);
      const date = new Date();
      date.setHours(hours);
      date.setMinutes(minutes);

      const newDate = addMinutes(date, 15);
      const newTime = format(newDate, 'HH:mm');

      setValue('hora_final', newTime);
    }

  }

  function remove15min() {
    if (horaFinal) {
      const [hours, minutes] = horaFinal.split(':').map(Number);
      const date = new Date();
      date.setHours(hours);
      date.setMinutes(minutes);

      const newDate = subMinutes(date, 15);
      const newTime = format(newDate, 'HH:mm');

      setValue('hora_final', newTime);
    }

  }

  // Ao sair do Início, mantém a duração atual; sem duração (o modal abre com 00:00), usa 15 min
  function changeStartTime(e) {
    const newStart = e.target.value;
    if (!isValidTime(newStart)) return;

    const previous = { start_time: startAtFocus.current, end_time: getValues('hora_final') };
    const hasDuration = isValidTime(previous.start_time) && isValidTime(previous.end_time) && previous.end_time > previous.start_time;
    const keptEnd = hasDuration ? moveStart(previous, newStart) : null;

    if (keptEnd) {
      setValue('hora_final', keptEnd);
      return;
    }

    const [hours, minutes] = newStart.split(':').map(Number);
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);

    const newDate = addMinutes(date, 15);
    const newTime = format(newDate, 'HH:mm');

    setValue('hora_final', newTime);
  }

  function deleteAgendamento() {
    setDeleting(true)
    Agendamentos.delete(id)
      .then(() => {
        SweetAlert.success('Agendamento removido com sucesso', 'Agendamento')
        setId(null)
        closeAll()
        listAll(false, getValues('date'))
      })
      .catch((error) => {
        SweetAlert.error(error?.response?.data?.message ?? error?.message, 'Agendamento');
        setConfirm(null);
      })
      .finally(() => setDeleting(false))
  }

  // Celular: o Excluir pede confirmação no rodapé. O menu de salvar abre por cima dele, e um segundo toque no mesmo lugar
  // (com a opção recusada e o menu já fechado) apagava o agendamento na hora. No computador, apaga direto, como antes
  function requestDelete() {
    if (phone) setConfirm('delete')
    else deleteAgendamento()
  }

  const title = id ? 'Detalhes do agendamento' : (nextTitle ? 'Novo agendamento - próximas sessões' : 'Novo agendamento');
  const listReady = series.enabled && series.sessions.length > 1 && !summary;
  const batchCount = series.sessions.length;
  const busy = saving || deleting;
  // Enquanto o prontuário do paciente escolhido é buscado, salvar gravaria o agendamento sem ele
  const saveDisabled = busy || prontuarioFill.loading || Boolean(series.enabled && series.blocking) || Boolean(singleCheck.blocking);
  const saveLabel = series.enabled && batchCount > 1 ? `Salvar ${batchCount} agendamentos` : 'Salvar';
  // "Salvar e enviar" só para o que ainda vai acontecer: com data e horário passados, não há o que enviar ao paciente
  const sharePast = upcomingSessions([{ date: dataInicial, start_time: horaInicial }]).length === 0;
  const shareReleasesSlot = releasesSlot(statusId);
  // Agendamento sem repetição (novo ou aberto pela agenda); o lote tem o envio no resumo, depois de salvar
  const showShare = !series.enabled;
  const shareDisabled = saveDisabled || sharePast || shareReleasesSlot;
  // Motivo do "Salvar e enviar" desabilitado: no computador, no title; no celular, escrito no menu (o toque não mostra o title)
  const shareReason = sharePast
    ? 'A data e o horário já passaram: não há o que enviar ao paciente'
    : (shareReleasesSlot ? 'Este status libera o horário: não há data e horário a enviar ao paciente' : null);
  // "Salvar e agendar próximas" (aberto) ou "Salvar e próximo" (novo sem repetição); o lote não tem
  const nextSave = id
    ? { label: 'Salvar e agendar próximas', onClick: saveAndScheduleNext, disabled: busy || prontuarioFill.loading || Boolean(singleCheck.blocking) }
    : (!series.enabled ? { label: 'Salvar e próximo', onClick: marcarPróximo, disabled: busy || prontuarioFill.loading || Boolean(singleCheck.blocking) } : null);
  // Celular: o Salvar, com as outras opções de salvar num menu ao lado. No computador, cada uma é um botão
  const splitSave = phone && (Boolean(nextSave) || showShare);
  const saveMenuOpen = splitSave && saveMenu;
  // A seta só abre o menu se alguma das opções puder salvar (não grava, não busca o prontuário, horário não recusado)
  const moreSavesDisabled = (!nextSave || nextSave.disabled) && (!showShare || shareDisabled);
  // Ícones do WhatsApp ao lado do paciente (agendamento aberto): a mesma regra dos Aniversariantes, com o 55; o fixo só
  // com 11 dígitos (é celular), primeiro o fixo e depois o celular, sem repetir o mesmo número
  const patientWhatsapps = [whatsappNumber({ telefone: getValues('telefone1') }), whatsappNumber({ telefone2: getValues('telefone2') })]
    .filter((number, index, list) => number && list.indexOf(number) === index);

  // Sem o menu na tela (lote, tela larga), ele fecha: não volta aberto quando o botão reaparecer
  useEffect(() => {
    if (!splitSave) setSaveMenu(false)
  }, [splitSave]);

  // Esc com o menu de salvar aberto fecha só o menu. O Modal e o Dropdown ouvem a tecla no document, e quem ouve primeiro
  // depende da ordem em que montaram: sem isto, o Esc podia fechar o modal e limpar o formulário
  function handleEscapeKeyDown(e) {
    if (!saveMenuOpen) return
    e.preventDefault()
    setSaveMenu(false)
  }

  // Esc na seta com o menu fechado fecha o modal, como no resto dele. O Dropdown trata o Esc da seta mesmo fechado, e o
  // Modal só fecharia se ouvisse antes: a tecla não segue para o document
  function handleToggleKeyDown(e) {
    if (e.key !== 'Escape' || saveMenuOpen) return
    e.stopPropagation()
    if (!busy && !listReady) requestClose()
  }

  const saveButton = (
    <Button variant="success" type="button" onClick={() => onSubmit()} disabled={saveDisabled}>
      {saving
        ? <><Spinner animation='border' size='sm' /> {series.enabled ? `Salvando ${batchCount} agendamentos...` : 'Salvando...'}</>
        : saveLabel}
    </Button>
  );

  return (
    <Container>

      <ModalSearchPacientes
        show={showCliente}
        handleClose={handleCloseCliente}
        setValues={setPacienteValue}
        handleShowModalCadastroPessoa={handleShowModalCadastroPessoa}
        handleCloseModalCadastroPessoa={handleCloseModalCadastroPessoa}
        loading={loading}
        setLoading={setLoading}
        setPhoto={() => { }}
      />

      <ModalSearchTecnicos
        show={showTecnico}
        handleClose={handleCloseTecnico}
        setValues={setTecnicoValue}
        loading={loading}
        setLoading={setLoading}
      />

      <ModalSearchTipoAtendimento
        show={showTipoAtendimento}
        handleClose={handleCloseTipoAtendimento}
        setValues={setValue}
        loading={loading}
        setLoading={setLoading}
      />

      <ModalSearchProntuarios
        show={showProntuarios}
        handleClose={handleCloseProntuarios}
        setValues={setValue}
        loading={loading}
        setLoading={setLoading}
        handleShowModalCadastroProntuario={handleShowModalCadastroProntuario}
        handleCloseModalCadastroProntuario={handleCloseModalCadastroProntuario}
        showProgress
        pacienteId={pacienteId}
        onSelect={setProntuarioDoctor}
      />

      <AgendamentoAttendance attendance={attendance} />

      <Modal show={showModalCadastroPessoa} fullscreen centered >
        <Modal.Header closeButton onHide={handleCloseModalCadastroPessoa} />
        <Modal.Body>
          <CadastroPaciente
            origem='modal'
            handleCloseModalCadastroPessoa={handleCloseModalCadastroPessoa}
            setValueModal={setPacienteValue}
            handleCloseCliente={handleCloseCliente}
          />
        </Modal.Body>
      </Modal>

      <Modal show={showModalCadastroProntuario} fullscreen centered >
        <Modal.Header closeButton onHide={handleCloseModalCadastroProntuario} />
        <Modal.Body>
          <CadastroProntuarios
            origem='modal'
            handleCloseModalCadastroProntuario={handleCloseModalCadastroProntuario}
            setValueModal={setValue}
            handleCloseProntuarios={handleCloseProntuarios}
            values={getValues()}
            showProgress
            onSaved={setProntuarioDoctor}
          />
        </Modal.Body>
      </Modal>


      <Modal show={show} onHide={requestClose} size='lg' centered backdrop='static' scrollable fullscreen='sm-down' dialogClassName='modal-agendamento' keyboard={!busy && !listReady} onEscapeKeyDown={handleEscapeKeyDown}>
        <Modal.Header closeButton={!busy} closeLabel='Fechar'>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <Form onSubmit={handleFormSubmit(onSubmit)}> */}

          {summary ? (
            <>
              <AgendamentoBatchSummary summary={summary} />
              {/* Na confirmação do Desfazer, o envio sai da tela */}
              {confirm !== 'undo' && !summary.releasesSlot ? <AgendamentoWhatsapp patient={summary.patient} pacienteId={summary.pacienteId} sessions={summary.sessions} opened={summary.whatsapp} /> : ''}
            </>
          ) : (
            <fieldset disabled={busy}>

              <Form.Group>
                <Form.Label>Paciente</Form.Label>
                <div className='d-flex'>
                  <Form.Control size='sm' type="text" {...register('paciente')} disabled />
                  <Button
                    variant='outline-secondary'
                    className='p-0 px-2 d-flex align-items-center ms-1'
                    onClick={handleShowCliente}
                  >
                    <IoSearch size={20} />
                  </Button>
                  <Button
                    variant='outline-secondary'
                    className='p-0 px-2 d-flex align-items-center ms-1'
                    onClick={showSelectedPaciente}
                  >
                    <FaRegEye size={20} />
                  </Button>

                  {patientWhatsapps.map((number) => (
                    <Button
                      key={number}
                      as="a"
                      href={`https://wa.me/${number}`}
                      target='_blank'
                      rel='noopener noreferrer'
                      variant='outline-secondary'
                      className='p-0 px-2 d-flex align-items-center ms-1'
                      title={`Abrir a conversa no WhatsApp: ${formatarTelefone(number.slice(2))}`}
                      aria-label={`Abrir a conversa no WhatsApp: ${formatarTelefone(number.slice(2))}`}
                    >
                      <FaWhatsapp size={20} />
                    </Button>
                  ))}

                </div>
              </Form.Group>

              <Form.Group className="mt-2">
                <Form.Label>Doutor</Form.Label>
                <div className='d-flex'>
                  <Form.Control size='sm' type="text" {...register('tecnico')} disabled />
                  <Button
                    variant='outline-secondary'
                    className='p-0 px-2 d-flex align-items-center ms-1'
                    onClick={handleShowTecnico}
                  >
                    <IoSearch size={20} />
                  </Button>

                </div>

              </Form.Group>

              <Form.Group className="mt-2">
                <Form.Label>Tipo de atendimento</Form.Label>
                <div className='d-flex'>
                  <Form.Control size='sm' type="text" {...register('tipo_atendimento')} disabled />
                  <Button
                    variant='outline-secondary'
                    className='p-0 px-2 d-flex align-items-center ms-1'
                    onClick={handleShowTipoAtendimento}
                  >
                    <IoSearch size={20} />
                  </Button>

                </div>

              </Form.Group>


              <Form.Group className="mt-2">
                <Form.Label>Prontuário</Form.Label>
                <div className='d-flex'>
                  <Form.Control size='sm' type="text" {...register('prontuario')} disabled placeholder={!pacienteId ? 'Selecione o paciente primeiro' : (prontuarioFill.loading ? 'Buscando o prontuário...' : '')} />
                  <Button
                    variant='outline-secondary'
                    className='p-0 px-2 d-flex align-items-center ms-1'
                    onClick={handleShowProntuarios}
                    disabled={!pacienteId}
                    title={pacienteId ? undefined : 'Selecione o paciente primeiro'}
                  >
                    <IoSearch size={20} />
                  </Button>
                  <Button
                    variant='outline-secondary'
                    className='p-0 px-2 d-flex align-items-center ms-1'
                    onClick={showSelectedProntuario}
                  >
                    <FaRegEye size={20} />
                  </Button>

                </div>

              </Form.Group>

              {lastSession ? <small className='text-muted d-block mt-2'>{lastSession}</small> : ''}

              <Row className='g-2 mt-0 mb-2 align-items-end'>
                <Form.Group as={Col} xs={12} lg={3}>
                  <Form.Label>Status</Form.Label>
                  <Form.Select size='sm' {...register('status')}>
                    {status?.map(item => {
                      return (
                        <option key={item.id} value={item.id}>{item.nome}</option>

                      )
                    })}
                  </Form.Select>
                </Form.Group>
                <Form.Group as={Col} xs={6} lg={3}>
                  <Form.Label>{series.enabled ? 'Data (1ª sessão)' : 'Data'}</Form.Label>
                  <Form.Control size='sm' type="date" {...register('data_inicial')} />
                </Form.Group>
                <Form.Group as={Col} xs={6} lg={2}>
                  <Form.Label>Início</Form.Label>
                  <Form.Control
                    size='sm'
                    type="time"
                    {...register('hora_inicial')}
                    onFocus={(e) => { startAtFocus.current = e.target.value }}
                    onBlur={changeStartTime} />
                </Form.Group>
                <Form.Group as={Col} xs={12} lg={4}>
                  <Form.Label>Fim</Form.Label>
                  <div className='d-flex gap-1'>
                    <Form.Control size='sm' type="time" {...register('hora_final')} disabled />
                    <Button size='sm' className='text-nowrap' onClick={add15min}>+15 min</Button>
                    <Button size='sm' className='text-nowrap' onClick={remove15min}>-15 min</Button>
                  </div>
                </Form.Group>
              </Row>

              <NextSlotNote nextSlot={nextSlot} />

              {!series.enabled ? <AgendamentoCheck check={singleCheck} /> : ''}

              {id === null ? (
                <RepeatAgendamento series={series} alert={batchAlert} onCloseAlert={() => setBatchAlert(null)} />
              ) : ''}
            </fieldset>
          )}

          {/* </Form> */}
        </Modal.Body>

        <Modal.Footer className='d-flex flex-wrap gap-2'>
          {confirm === 'undo' && summary ? (
            <>
              <span className='me-auto' role='status'>Excluir os {summary.ids.length} agendamentos criados agora?</span>
              <Button variant='outline-secondary' autoFocus onClick={() => setConfirm(null)} disabled={saving}>Voltar</Button>
              <Button variant='danger' onClick={undoBatch} disabled={saving}>
                {saving ? <><Spinner animation='border' size='sm' /> Excluindo...</> : 'Excluir'}
              </Button>
            </>
          ) : summary ? (
            <>
              {summary.single ? '' : <Button variant='outline-danger' className='me-auto' onClick={() => setConfirm('undo')}>Desfazer</Button>}
              <Button variant='outline-primary' onClick={() => { goToDate(summary.sessions[0].date); closeAll(); }}>Ver na agenda</Button>
              <Button variant='success' autoFocus onClick={closeAll}>Concluir</Button>
            </>
          ) : confirm === 'discard' ? (
            <>
              <span className='me-auto' role='status'>Descartar as {batchCount} sessões montadas?</span>
              <Button variant='outline-secondary' autoFocus onClick={() => setConfirm(null)}>Continuar editando</Button>
              <Button variant='danger' onClick={closeAll}>Descartar</Button>
            </>
          ) : confirm === 'delete' ? (
            <>
              <span className='me-auto' role='status'>Excluir este agendamento?</span>
              <Button variant='outline-secondary' autoFocus onClick={() => setConfirm(null)} disabled={deleting}>Voltar</Button>
              <Button variant='danger' onClick={deleteAgendamento} disabled={deleting}>
                {deleting ? <><Spinner animation='border' size='sm' /> Excluindo...</> : 'Excluir'}
              </Button>
            </>
          ) : series.enabled && series.allAlreadyScheduled ? (
            <>
              <small className='me-auto'>{series.blocking}</small>
              <Button variant='success' onClick={closeAll}>Concluir</Button>
            </>
          ) : (
            <>
              {id ? <Button variant="outline-danger" type="button" className='me-auto' onClick={requestDelete} disabled={busy}>
                {deleting ? <><Spinner animation='border' size='sm' /> Excluindo...</> : 'Excluir'}
              </Button> : ''}

              {series.enabled && (series.blocking || series.reminder) ? (
                <small className={`me-auto ${series.blocking ? 'text-danger' : 'text-warning-emphasis'}`}>{series.blocking ?? series.reminder}</small>
              ) : ''}

              {singleCheck.blocking ? <small className='me-auto text-danger'>{singleCheck.blocking}</small> : ''}

              {!splitSave && nextSave ? (
                <Button variant="outline-success" type="button" onClick={nextSave.onClick} disabled={nextSave.disabled}>
                  {nextSave.label}
                </Button>
              ) : ''}

              {/* Salva e abre o WhatsApp do paciente com a data e o horário */}
              {!splitSave && showShare ? (
                <Button
                  variant="outline-success"
                  type="button"
                  className='d-flex align-items-center gap-1'
                  onClick={() => onSubmit('whatsapp')}
                  disabled={shareDisabled}
                  aria-label='Salvar e enviar ao paciente pelo WhatsApp'
                  title={shareReason ?? 'Salva e abre o WhatsApp do paciente com a data e o horário'}
                >
                  <FaWhatsapp aria-hidden='true' /> Salvar e enviar
                </Button>
              ) : ''}

              {/* Celular: o Salvar ocupa a linha e a seta ao lado abre, para cima, as outras opções de salvar */}
              {splitSave ? (
                <Dropdown as={ButtonGroup} drop='up' align='end' className='modal-agendamento-save' show={saveMenuOpen} onToggle={(next) => setSaveMenu(next && !moreSavesDisabled)}>
                  {saveButton}
                  {/* Gravando, a seta fica só com aria-disabled (e a aparência de desabilitada): o foco volta para ela quando o
                      menu fecha, e não se perde no meio da tela */}
                  <Dropdown.Toggle
                    split
                    variant='success'
                    aria-label='Mais opções de salvar'
                    disabled={moreSavesDisabled && !busy}
                    aria-disabled={busy || undefined}
                    className={busy ? 'disabled' : undefined}
                    onKeyDown={handleToggleKeyDown}
                  />
                  <Dropdown.Menu>
                    {nextSave ? (
                      <Dropdown.Item as='button' type='button' onClick={nextSave.onClick} disabled={nextSave.disabled}>{nextSave.label}</Dropdown.Item>
                    ) : ''}
                    {showShare ? (
                      <Dropdown.Item
                        as='button'
                        type='button'
                        onClick={() => onSubmit('whatsapp')}
                        disabled={shareDisabled}
                        aria-label='Salvar e enviar ao paciente pelo WhatsApp'
                        aria-describedby={shareReason ? 'agendamento-share-reason' : undefined}
                      >
                        <FaWhatsapp aria-hidden='true' /> Salvar e enviar
                        {shareReason ? <small id='agendamento-share-reason' className='d-block text-muted'>{shareReason}</small> : ''}
                      </Dropdown.Item>
                    ) : ''}
                  </Dropdown.Menu>
                </Dropdown>
              ) : saveButton}
            </>
          )}
        </Modal.Footer>
      </Modal>
    </Container>
  )
}

export default ModalNovoAgendamento
